<script setup>
  import MapLayout from '@/components/MapLayout.vue';
</script>

<template>
  <MapLayout />
</template>
